<template>
  <div :class="$style.wrapper">
    <div :class="$style.left">
      <img
        src="@/assets/back.svg"
        :class="$style['back-ico']"
        @click="$emit('back')"
      />
    </div>
    <div :class="$style.title">{{ title }}</div>
    <div :class="$style.right"></div>
  </div>
</template>
<script>
import i18n from '@/i18n'
export default {
  name: 'TopBarBackMobile',
  props: {
    title: {
      type: String,
      default: () => i18n.t('6c4746f45e')
    }
  }
}
</script>
<style lang="scss" module>
.wrapper {
  background: #ffffff;
  box-sizing: border-box;
  height: 88px;
  display: flex;
  align-items: center;
}
.left {
  margin-left: 32px;
  width: 40px;
}
.back-ico {
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.title {
  flex: 1;
  min-width: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
}
.right {
  margin-right: 32px;
  width: 40px;
}
</style>
